// extracted by mini-css-extract-plugin
export default {"radio":"KPIFormatSelect_radio__XiBg6","selected":"KPIFormatSelect_selected__j1PtS"};